import React from "react";
import { useAppContext } from "../../store/AppContext";
import { t } from "i18next";
import { isActive, isSubscribed, isTrialing } from "../../utils/user";
import { timestampToDate } from "../../services/firebase";
import usePricing from "../../hooks/usePricing";
import colors from "../../styles/colors";
import { typography } from "../../styles/typography";
import { ANNUAL, MONTHLY } from "../../constans";
import { addDaysToDate, getDaysDifference } from "../../utils/Date";

const SubscriptionStatus = ({containerStyle, titleStyle}) => {
    const pricing = usePricing()
    const { state } = useAppContext()
    const user = state.user

    function getInterval(){
        return user.subscription.scheduledPlan ?? user.subscription.plan.interval
    }

    function trans(key, options) {
        return t("changetrainingmode_" + key, options)
    }

    if (!user) return null


    return <div style={{...style.cardContent, ...containerStyle}}>
        <div style={{...style.cardTitle, ...titleStyle}}>{trans(37)}</div>
        <div style={style.freeTrial} className='mt-4'>

            {`${isSubscribed(user) ? trans(39) : trans(63)} ${isTrialing(user) ? trans(49) : ''}
                ${isSubscribed(user) ? ' - ' : ''}
                ${user.subscription.cancelAtPeriodEnd ? trans(47) : isTrialing(user) ? trans(491) : isSubscribed(user) ? trans(494) : ''} 
                ${user.subscription.cancelAtPeriodEnd ? '' :
                    isTrialing(user) ? `\n${getInterval() == MONTHLY ? trans(492, { amount: pricing.monthly }) : trans(493, { amount: pricing.annual })}` : ''}
                ${isActive(user) ? `\n- ${getInterval() == MONTHLY ? `${t('plan_selection_71')} $${pricing.monthly}` : `${t('plan_selection_73')} $${pricing.annual}`}` : ''} 
                          `}</div>
        <div style={style.freeTrial} className='mt-4'>{trans(50, {
            date: timestampToDate(user.createDate).toDateString()
        })}</div>
        <div style={style.freeTrial} className='mt-4'>{
            user.subscription.cancelAtPeriodEnd ?
                trans(51, {
                    date: new Date(user.subscription.trialEnd * 1000).toDateString(),
                    remainder: getDaysDifference(user.subscription.trialEnd * 1000, new Date())
                }) : isTrialing(user) ?
                    t('payment_99', { date: addDaysToDate(new Date(user.subscription.trialEnd * 1000), 1).toDateString() }) :
                    trans(58, {date: new Date(user.subscription.currentPeriodEnd*1000).toDateString()})
        } </div>
        {(isTrialing(user) && !user.subscription.cancelAtPeriodEnd) && <div style={style.freeTrial} className='mt-4'>{trans(55)}</div>}
    </div>
}


const style = {
    cardContent: {
        color: '#fff',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        ...typography.body["15_regular"],
    },
    freeTrial: {
        color: colors.mono300
    },
    cardTitle: {
        color: colors.mono300,
    }
}

export default SubscriptionStatus